import React from 'react';

import { Container } from '@/shared/components/EarnBanner/ui/Container';
import bg from '@/shared/components/EarnBanner/assets/bg.svg';
import { ReactComponent as EarnEth } from '@/shared/assets/earn-eth.svg';
import { ReactComponent as EarnUsd } from '@/shared/assets/earn-usd.svg';
import { ReactComponent as ArrowRight } from '@/shared/components/EarnBanner/assets/arrow-right.svg';
import { Content } from '@/shared/components/EarnBanner/ui/Content';
import { Block } from '@/shared/components/EarnBanner/ui/Block';
import { IconsContainer } from '@/shared/components/EarnBanner/ui/IconsContainer';
import { StrategyName } from '@/shared/components/EarnBanner/ui/StrategyName';
import { VerticalSeparator } from '@/shared/components/EarnBanner/ui/VerticalSeparator';
import { TvlApyBlock } from '@/shared/components/EarnBanner/ui/TvlApyBlock';
import { TvlApyLine } from '@/shared/components/EarnBanner/ui/TvlApyLine';
import { TvlApyValue } from '@/shared/components/EarnBanner/ui/TvlApyValue';
import { formatNumber } from '@/shared/utils';
import { NameAndIconContainer } from '@/shared/components/EarnBanner/ui/NameAndIconContainer';
import { useTheme } from '@/services/theme';
import {
  lidoEarnEth,
  lidoEarnEthVaultId,
} from '@/features/vaults/constants/vaults/lido/lido-earn-eth';
import {
  lidoEarnUsd,
  lidoEarnUsdVaultId,
} from '@/features/vaults/constants/vaults/lido/lido-earn-usd';
import { ArrowRightContainer } from '@/shared/components/EarnBanner/ui/ArrowRightContainer';
import { formatPercentage } from '@/shared/utils/format/formatPercentage';
import { useVaultTvlAndApy } from '@/features/vaults/hooks/useVaultTvlAndApy';

export const EarnBanner: React.FC = () => {
  const { theme } = useTheme();
  const lidoEarnEthVaultData = useVaultTvlAndApy(lidoEarnEth);
  const lidoEarnUsdVaultData = useVaultTvlAndApy(lidoEarnUsd);

  return (
    <Container style={{ backgroundImage: `url(${bg})` }} theme={theme}>
      <Content>
        <Block>
          <VerticalSeparator />
          <IconsContainer href={`/vaults/${lidoEarnEthVaultId}`}>
            <EarnEth />
            <NameAndIconContainer>
              <StrategyName>
                <span>EarnETH</span>
                <ArrowRightContainer>
                  <ArrowRight className="animated" />
                  <ArrowRight className="animated" />
                </ArrowRightContainer>
              </StrategyName>
            </NameAndIconContainer>
          </IconsContainer>
          <TvlApyBlock>
            <TvlApyLine>
              <span>TVL</span>
              <TvlApyValue>
                $
                {lidoEarnEthVaultData.loading
                  ? '...'
                  : formatNumber(lidoEarnEthVaultData.tvl.usd, 0)}
              </TvlApyValue>
            </TvlApyLine>
            <TvlApyLine>
              <span>{lidoEarnEthVaultData.apy.type}</span>
              <TvlApyValue>
                {lidoEarnEthVaultData.loading
                  ? '...'
                  : formatPercentage(lidoEarnEthVaultData.apy.value, 2)}
              </TvlApyValue>
            </TvlApyLine>
          </TvlApyBlock>
        </Block>
        <Block>
          <VerticalSeparator />
          <IconsContainer href={`/vaults/${lidoEarnUsdVaultId}`}>
            <EarnUsd />
            <NameAndIconContainer>
              <StrategyName>
                <span>EarnUSD</span>
                <ArrowRightContainer>
                  <ArrowRight className="animated" />
                  <ArrowRight className="animated" />
                </ArrowRightContainer>
              </StrategyName>
            </NameAndIconContainer>
          </IconsContainer>
          <TvlApyBlock>
            <TvlApyLine>
              <span>TVL</span>
              <TvlApyValue>
                $
                {lidoEarnUsdVaultData.loading
                  ? '...'
                  : formatNumber(lidoEarnUsdVaultData.tvl.usd, 1)}
              </TvlApyValue>
            </TvlApyLine>
            <TvlApyLine>
              <span>{lidoEarnUsdVaultData.apy.type}</span>
              <TvlApyValue>
                {lidoEarnUsdVaultData.loading
                  ? '...'
                  : formatPercentage(lidoEarnUsdVaultData.apy.value, 2)}
              </TvlApyValue>
            </TvlApyLine>
          </TvlApyBlock>
        </Block>
      </Content>
    </Container>
  );
};
